module.exports = __webpack_public_path__ + "1147ededfbc9bd36cd0a625266de479b.svg";